const groupBy = (array, key) =>
  array.reduce((result, currentValue) => {
    (result[`${currentValue[key].name}`] =
      result[`${currentValue[key].name}`] || []).push(currentValue);
    return result;
  }, {});

export default groupBy;
